import type React from "react";
import { acrylicStyles, acrylicDialogSurface } from "../../theme/acrylic";

// Shared visual theme for the diagnostics tag-selection dialogs — now a thin
// layer over the Acrylic Glass theme module (src/theme/acrylic.ts): frosted
// overlay over a rounded, resizable glass card with a header (title + ✕), a
// scrollable body, and a footer carrying OK (primary) / Cancel (secondary).
export const tagSelectStyles = {
  ...acrylicStyles,
  // Centres a 560 × 520 card which then grows from this anchor on resize
  // rather than re-centering each tick (see acrylicDialogSurface docs).
  dialog: acrylicDialogSurface({
    width: 560,
    height: 520,
    minWidth: 420,
    minHeight: 360,
  }),
  body: {
    ...acrylicStyles.body,
    gap: 16,
  },
  section: {
    ...acrylicStyles.section,
    flex: 1,
    minHeight: 0,
  },
  tableWrap: {
    ...acrylicStyles.tableWrap,
    flex: 1,
    minHeight: 0,
    display: "flex",
  },
} as const satisfies Record<string, React.CSSProperties>;
